import { z } from 'zod';
import { teamSlugSchema } from '../schemas/team.js';
/**
 * Manifest endpoints (`/api/.well-known/marketplace.json` and
 * `/api/.well-known/marketplace.<team>.json`) bypass the success/data envelope
 * — `routeOptions.config.skipEnvelope = true`. The wire body IS the
 * manifest object directly; consumers must NOT expect `{success, data}`.
 *
 * Both routes return the canonical `manifestSchema` (`schemas/manifest.ts`)
 * — the registry imports it directly. No per-route response alias is
 * exported here because the alias would be a one-line indirection that
 * silently drifts if the manifest shape ever splits between root and team
 * variants.
 */
/**
 * Path component validator for `:teamName`. Reuses the shared
 * `teamSlugSchema` (spec §5.5 grammar) so the manifest URL grammar matches
 * the create-side validation — a slug that can never be created is also
 * one that can never resolve to a manifest.
 */
export const getTeamManifestParamsSchema = z.object({
    teamName: teamSlugSchema,
});
//# sourceMappingURL=manifest.js.map